export default __webpack_public_path__ + "static/lg-mask-image-dark-5a6f0b100d3088cffcb1dc941840650d.png";